'use strict';

angular.module('myConsultApp').factory('LogoutService', function ($resource, ENV) {
  var logoutService = {};

  logoutService.logout = function (logoutParams) {
    var logout = $resource(
      ENV.tokenApiEndpoint + '/o/revoke_token/',
      {},
      {
        save: {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
          transformRequest: function (data, headersGetter) {
            return angular.isObject(data) && String(data) !== '[object File]'
              ? jQuery.param(data)
              : data;
          },
        },
      },
    );

    return logout.save(logoutParams).$promise.then(function () {
      return logout;
    });
  };

  return logoutService;
});
